export const ALL_CATEGORY_ID = 'ALL';
export const FREE_CATEGORY_ID = 'FREE';
